<template>
    <div>
        <div class="cart panel-2">
            <div class="cart-title">
                {{$t('components.shopping_cart.shopping_cart')}}
            </div>
            <div class="travels">
                <div v-if="shopping_cart && shopping_cart.legs">

                    <div class="travel" v-for="(leg, index) in shopping_cart.legs" v-bind:key="leg">
                        <div class="travel-title" v-if="shopping_cart.legs.length==2">
                            <div v-if="index==0">
                                {{$t('components.shopping_cart.outward_trip')}}
                            </div>
                            <div v-else>
                                {{$t('components.shopping_cart.backward_trip')}}
                            </div>
                        </div>
                        <div class="travel-from-to notranslate">
                            {{leg.steps[0].transit.departure_stop.name}}&nbsp;-&nbsp;{{leg.steps[leg.steps.length-1].transit.arrival_stop.name}}
                        </div>
                        <div class="travel-details">
                            <div v-for="step in leg.steps" v-bind:key="step">
                                <div v-if="step.transit" class="travel-detail">
                                    <div class="travel-detail-from">
                                        <div class="travel-detail-date">
                                            {{getDateString(step.transit.local_depart_at)}}&nbsp;&nbsp;{{getTimeString(step.transit.local_depart_at)}}
                                        </div>
                                        <div class="travel-detail-stop notranslate">{{step.transit.departure_stop.name}}</div>
                                    </div>
                                    <div class="travel-detail-to">
                                        <div class="travel-detail-date">
                                            {{getDateString(step.transit.local_arrive_at)}}&nbsp;&nbsp;{{getTimeString(step.transit.local_arrive_at)}}
                                        </div>
                                        <div class="travel-detail-stop notranslate">{{step.transit.arrival_stop.name}}</div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <table class="travel-passengers">
                            <tr v-for="product in leg.product_lines" class="travel-passenger" v-bind:key="product">
                                <td class="passenger">
                                    {{product.quantity}}
                                    &nbsp;&nbsp;
                                    {{product.title}}
                                </td>


                                <td class="discount">
                                    <template v-if="product.discount_amount<0 && shopping_cart.payment_type != 'reservation'">
                                        {{getDiscountPercentage(product)}}&nbsp;%
                                        <template v-if="getDiscountPercentage(product)>=50">
                                            {{$t('components.shopping_cart.group_discount')}}
                                        </template>
                                        <template v-else>
                                            {{$t('components.shopping_cart.discount')}}
                                        </template>
                                        &nbsp; {{ parseFloat(product.discount_amount * product.quantity).toFixed(2)}} {{$t('components.shopping_cart.norwegian_krone')}}
                                    </template>
                                </td>
                                <td class="price">
                                    <template v-if="shopping_cart.payment_type != 'reservation'">
                                        {{parseFloat(product.line_total).toFixed(2)}} {{$t('components.shopping_cart.norwegian_krone')}}
                                    </template>
                                </td>

                            </tr>


                            <tr v-if="shopping_cart.payment_type != 'reservation'">
                                <td></td>
                                <td></td>
                                <td class="price">
                                    {{parseFloat(leg.total).toFixed(2)}} {{$t('components.shopping_cart.norwegian_krone')}}
                                </td>
                            </tr>

                        </table>
                    </div>
                </div>
            </div>

            <table class="cart-summary">

                <tr v-if="shopping_cart.discount_total<0 && shopping_cart.payment_type != 'reservation'">
                    <td>
                        <span>{{$t('components.shopping_cart.discount')}}</span>
                    </td>
                    <td class="price">
                        {{parseFloat(shopping_cart.discount_total).toFixed(2)}} {{$t('components.shopping_cart.norwegian_krone')}}
                    </td>
                </tr>
                <template v-if="shopping_cart.payment_type != 'reservation'">
                <tr v-for="vat_line in shopping_cart.tax_lines" v-bind:key="vat_line">
                    <td>
                        <span>{{$t('components.shopping_cart.vat')}} {{vat_line.rate*100}} % </span>
                    </td>
                    <td class="price">
                        {{parseFloat(vat_line.amount).toFixed(2)}}
                        {{$t('components.shopping_cart.norwegian_krone')}}
                    </td>
                </tr>
            </template>
                <tr class="cart-total">
                    <td>
                        <span>{{$t('components.shopping_cart.total')}}</span>
                    </td>
                    <td class="price">
                        <template v-if="shopping_cart.payment_type != 'reservation'">{{parseFloat(shopping_cart.total).toFixed(2)}}</template>
                        <template v-else>0</template>
                        {{$t('components.shopping_cart.norwegian_krone')}}                       
                    </td>
                </tr>
            </table>
            
        </div>
        <ul class="n2-valid" v-bind:class="{'n2-errors':errors}">
            <li v-for="error in errors" v-bind:key="error">{{ error }}</li>
        </ul>
    </div>
</template>
<script>
    import { mapGetters } from 'vuex';

    export default {
        name: 'app-autocomplete',
        props: ['label', 'value', 'items', 'disabled', 'auto_stop_loading', 'text_field', 'separator', 'value_field', 'css_class', 'errors'],
        data: function () {
            return {
                filterText: '',
                filterdItems: [],
                itemId: '',
                hiddenList: true,
                selectedPosition: -1,
                inputClass: this.css_class ? this.css_class : 'n2-input-default',
            };
        },
        computed: {
            ...mapGetters('globalization', [
                'app_locale',
                'locale',
            ]),
            shopping_cart: {
                get() {
                    return this.$store.state.shopping_cart_store.shopping_cart
                }
            }
        },
        methods: {
            getTimeString: function (source) { return new Date(source).toLocaleString('en-GB', { hour: '2-digit', minute: '2-digit' }); },
            getDateString: function (source) { return new Date(source).toLocaleString(this.locale, { dateStyle: 'short' }); },
            getDiscountPercentage: function (product) {
                let p = -product.discount_amount * 100 / product.list_price;
                return parseInt(p);
            },
        }
    }
</script>
<style lang="sass">
</style>
